import { ui } from "./ui";

export type RoomExitOutcome = "left" | "left_unconfirmed" | "ended" | "end_unconfirmed" | "removed";

export interface RoomExitReceipt {
  outcome: RoomExitOutcome;
  roomTitle: string;
}

export function roomExitNavigationState(receipt: RoomExitReceipt): { roomExit: RoomExitReceipt } {
  return { roomExit: receipt };
}

export function roomExitReceiptFromState(value: unknown): RoomExitReceipt | null {
  if (!value || typeof value !== "object") return null;
  const candidate = (value as { roomExit?: unknown }).roomExit;
  if (!candidate || typeof candidate !== "object") return null;
  const receipt = candidate as Partial<RoomExitReceipt>;
  if (!(["left", "left_unconfirmed", "ended", "end_unconfirmed", "removed"] as const).includes(receipt.outcome as RoomExitOutcome)) return null;
  if (typeof receipt.roomTitle !== "string" || !receipt.roomTitle.trim() || receipt.roomTitle.length > 100) return null;
  return { outcome: receipt.outcome as RoomExitOutcome, roomTitle: receipt.roomTitle.trim() };
}

export function roomExitNotice(receipt: RoomExitReceipt): { tone: "info" | "success" | "warning" | "danger"; title: string; body: string } {
  if (receipt.outcome === "ended") return {
    tone: "success",
    title: ui("Room ended for everyone", "Комната завершена для всех"),
    body: ui(`${receipt.roomTitle} is closed and its current participant sessions can no longer reconnect.`, `«${receipt.roomTitle}» закрыта, текущие участники больше не переподключатся.`),
  };
  if (receipt.outcome === "end_unconfirmed") return {
    tone: "warning",
    title: ui("Talk could not confirm the room ended", "Не удалось подтвердить, что комната завершена"),
    body: ui(`You left ${receipt.roomTitle}, but other participants may still be connected. Reopen History before assuming the room is closed.`, `Вы вышли из «${receipt.roomTitle}», но другие участники могли остаться. Загляните в историю, прежде чем считать комнату закрытой.`),
  };
  if (receipt.outcome === "removed") return {
    tone: "danger",
    title: ui("You were removed from the room", "Вас убрали из комнаты"),
    body: ui(`Your session for ${receipt.roomTitle} can no longer rejoin. Ask a host for a fresh invitation if this was unexpected.`, `В «${receipt.roomTitle}» этой сессией больше не войти. Если это неожиданно, попросите ведущего прислать новую ссылку.`),
  };
  if (receipt.outcome === "left_unconfirmed") return {
    tone: "warning",
    title: ui("You left this browser", "Вы вышли в этом браузере"),
    body: ui(`Talk could not confirm that your participant session for ${receipt.roomTitle} was closed on the server.`, `Не удалось подтвердить, что сессия в «${receipt.roomTitle}» закрыта на сервере.`),
  };
  return {
    tone: "info",
    title: ui("You left the room", "Вы вышли из комнаты"),
    body: ui(`${receipt.roomTitle} can continue for the other participants.`, `«${receipt.roomTitle}» может продолжаться для остальных.`),
  };
}
